import { Component, OnInit } from "@angular/core";
import { PoModule, PoNotificationService, PoTableAction, PoPageFilter } from "@po-ui/ng-components";
import { Router } from "@angular/router";
import { ClientesListService } from "./clientes-list.service";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-clientes-list",
  templateUrl: "./clientes-list.component.html",
  styleUrls: ["./clientes-list.component.css"],
  standalone: false,
})
export class ClientesListComponent implements OnInit {
  filterModel: string = '';  // Definição correta do filtro
  clientesList: Array<any> = new Array();
  actions: Array<PoTableAction> = [
    {
      action: this.viewclientes.bind(this),
      icon: "po-icon po-icon-eye",
      label: "Visualizar"
    }
    //   { action: this.deleteCustomer.bind(this), icon: 'po-icon-delete', label: 'Excluir' }
  ];
  columns: Array<any>;

  public loading: boolean = true;

  // Remover ngModel e ajustar para usar p-value
  public readonly filter: PoPageFilter = {
    action: this.showAction.bind(this, "Filter"),
    placeholder: "Nome do cliente",
  };

  constructor(
    private clientesListService: ClientesListService,
    private router: Router,
    private poNotification: PoNotificationService
  ) {}

  ngOnInit() {
    this.updateclientesList("A");
    this.columns = this.clientesListService.getColumns();
    this.loading = false;
  }

  updateclientesList(filtro: string): void {
    this.clientesListService.getclientessList(filtro).subscribe(response => {
      this.clientesList = response;
    });
  }

  viewclientes(clientes: any) {
    this.router.navigate([`clientes-view/${clientes.cgc}`], {});
  }

  onClick() {
    this.router.navigate(["prospect-form"], {});
  }

  // Método para capturar a mudança no filtro
  showAction(label: string): void {
    this.updateclientesList(this.filterModel);  // Atualiza a lista com o valor do filtro
    //this.poNotification.success(`Action clicked: ${label + this.filterModel}`);
  }
}
